<template>
  <base-page-layout title="SMS">
    <v-layout class="my-3 btn-nova">
      <v-spacer />
      <mf-button icon="add" data-cy="newSMSCampaign" label="Nova campanha" @click="redirect()"></mf-button>
    </v-layout>

    <v-container fluid class="px-0 pt-5" grid-list-lg>
      <v-layout>
        <v-flex v-for="(card, index) in cards" :key="index" xs4>
          <cbm-card :number-text="card.value" :title="card.text" :tooltip="card.helpText" :boolean-loader="card.loading" />
        </v-flex>
      </v-layout>
    </v-container>

    <campaigns-table v-if="isFranchisee" mode="sms" logsTag="CAMPAIGNS" :franchisee="true" class="mb-3" :items-filter="filterList[0]">
      <template v-slot:title> Campanhas da rede </template>
    </campaigns-table>
    <campaigns-table mode="sms" logsTag="CAMPAIGNS" :items-filter="filterList[1]">
      <template v-slot:title> Minhas campanhas </template>
    </campaigns-table>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CbmCard from '@/components/CbmCard.vue'
import CampaignsTable from '@/modules/campanhas/views/components/index/CampaignsTable.vue'
import { mapGetters } from 'vuex'
import { QUERY_GET_CAMPAIGNS_COUNTS_PER_STATUS, QUERY_GET_CREDITS } from '../../graphql'
import { getStatusLabel, localeString } from '@/config/helpers.js'

export default {
  components: {
    BasePageLayout,
    CbmCard,
    CampaignsTable,
  },
  data: () => ({
    loading: {
      credits: false,
      counts: false,
    },
    smsCredits: 0,
    activeCampaignCount: 0,
    scheduledCampaignsCount: 0,
    filterList: [
      [
        { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
        { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
      ],
      [
        { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
        { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
        { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
      ],
    ],
  }),
  computed: {
    ...mapGetters(['smsCountsChanged']),

    cards() {
      return [
        {
          value: localeString(this.smsCredits || 0),
          text: 'Créditos',
          helpText: 'Créditos podem ser adquiridos em contato com seu consultor',
          loading: this.loading.credits,
        },
        {
          value: localeString(this.activeCampaignCount || 0),
          text: 'Campanhas ativas',
          isInteger: true,
          loading: this.loading.counts,
        },
        {
          value: localeString(this.scheduledCampaignsCount || 0),
          text: 'Envios agendados',
          isInteger: true,
          helpText: this.isFranchisee ? 'Envios que foram programados por você. Disparos da rede não são contabilizados.' : null,
          loading: this.loading.counts,
        },
      ]
    },

    isFranchise() {
      // rede
      if (!this.$getLoggedUser().is_franchise) return false
      return this.$getLoggedUser().is_franchise
    },

    isFranchisee() {
      // franquia
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
  },
  watch: {
    smsCountsChanged(value) {
      if (value) {
        this.getSmsCampaignsCounts()
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.getSmsCredits()
      this.getSmsCampaignsCounts()
    },
    async getSmsCredits() {
      try {
        this.loading.credits = true
        const result = await this.$apollo.query({
          query: QUERY_GET_CREDITS,
          fetchPolicy: 'no-cache',
        })
        this.smsCredits = result.data.balance
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao consultar os créditos disponíveis.' })
        console.log(e)
      }
      this.loading.credits = false
    },
    async getSmsCampaignsCounts() {
      try {
        this.loading.counts = true
        const result = await this.$apollo.query({
          query: QUERY_GET_CAMPAIGNS_COUNTS_PER_STATUS,
          fetchPolicy: 'no-cache',
          variables: {
            isIndustry: false,
          },
        })
        this.$store.commit('smsCountsChanged', false)
        this.scheduledCampaignsCount = result.data.campaignsCountsPerStatus.SCHEDULED
        this.activeCampaignCount = result.data.campaignsCountsPerStatus.ACTIVE
        this.finishedCampaignsCount = result.data.campaignsCountsPerStatus.FINISHED
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao calcular as campanhas agendadas.' })
        console.log(e)
      } finally {
        this.loading.counts = false
      }
    },
    redirect() {
      this.$router.push('/campanhas/sms/nova').catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-nova {
  margin-top: -54px !important;
}
</style>
